module.exports = __webpack_public_path__ + "img/arrow-down.d1c99dad.svg";